export default {
  black: {
    light: '#322f37',
    default: '#19171c'
  },
  grey: {
    default: 'hsla(0, 0%, 100%, 0.7)',
    dark: '#6e6779'
  },
  red: {
    default: '#ec1313'
  },
  purple: {
    light: '#bca3ec',
    default: '#6441a4',
    dark: '#4b367c',
    superDark: '#332f3f',
    darkest: '#25222d'
  },
  white: {
    light: '#fff',
    default: '#f3f7f9',
    dark: '#f3f3f3'
  }
  // TODO 'linear-gradient(0deg, #25222d 0, rgba(37, 34, 45, 0.9) 25%, rgba(37, 34, 45, 0.3))',
};
